<template>
  <img :src=image>
</template>

<script>
  export default {
    name: "fragment",
    props: {
      beddingType: {
        type: String,
        validator: function (value) {
          // The value must match one of these strings
          return ['low', 'high'].indexOf(value) !== -1
        }
      },
      variant:String,
      color:String,
      belt:String,
      wideness:String,
      imgURL: String

    }, computed: {
      image: function () {
        if(this.belt ===  "belt"){
        return this.imgURL + "Lederriemen/" + this.variant + "-Riemen/" + this.wideness +"/top/fragment/"+ ['belt','fragment', this.color].join('_')+".png"
        }else{
          return this.imgURL + "Lederriemen/" + this.variant + "-Riemen/" + this.wideness +"/bottom/fragment/"+ ['belt','fragment', this.color].join('_')+".png"
        }
        // if (this.type === "x") {
        //   // if(this.chosenBelt!=="1") this.chosenBelt=2;
        //   return this.imgURL + "Lederriemen/X-Riemen/" + this.wideness + "/" + ['belt', this.chosenBelt, this.wideness, this.type, 'fragment', this.variant].join('_') + ".png"
        // }
        // return this.imgURL + "Lederriemen/Y-Riemen/" + this.wideness + "/" + ['belt', this.wideness, this.type, 'fragment', this.variant].join('_') + ".png"

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragment.vue